import { Box, Typography, Chip, Divider, Checkbox } from '@material-ui/core';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'components/Icon';
import { IssuedCoupon } from 'types/Coupon';

const getDate = (date: IssuedCoupon['expiryDate']) =>
  date === '0000-00-00'
    ? 'No expiry date set'
    : format(new Date(date), 'yyyy-MM-dd');

const Coupon: React.FC<{
  coupon: IssuedCoupon;
  removeIssuedCoupon: (id: string) => void;
  toggleCoupon: (id: string) => void;
  checked: boolean;
  used: boolean;
}> = ({ coupon, removeIssuedCoupon, toggleCoupon, checked, used }) => {
  const { t } = useTranslation('campaigns');

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      style={{ cursor: 'pointer' }}
      onClick={() => toggleCoupon(coupon.uniqueIdentifier)}
    >
      <Checkbox checked={checked} />
      <Box display="flex" padding="1rem" flexDirection="column">
        <Typography variant="h5">{coupon.uniqueIdentifier}</Typography>
        <Typography variant="body1">{coupon.couponCode}</Typography>
      </Box>
      <Box
        justifyContent="flex-end"
        display="flex"
        gridGap="0.2rem"
        flex={1}
        alignItems="center"
      >
        <Typography variant="h5">{getDate(coupon.expiryDate)}</Typography>
        <Chip
          style={{ backgroundColor: used ? 'green' : 'red' }}
          size="medium"
          label={t('coupons.badge', {
            context: used ? 'applied' : 'notApplied',
          })}
        />
        <Icon
          name="icon_trash_alt"
          action={e => {
            e.stopPropagation();
            removeIssuedCoupon(coupon.uniqueIdentifier);
            toggleCoupon(coupon.uniqueIdentifier);
          }}
        />
      </Box>
      <Divider />
    </Box>
  );
};

export default Coupon;
